/*
 * File: utilities.ts
 * Project: a-a
 * File Created: Monday, 28th October 2024 9:53:49 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 7th November 2025 11:03:44 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
export class Utilities {
  public static handleLoginError = (error: any, setError: (message: string) => void) => {
    // const message = error?.response?.data?.name || error?.response?.data;
    // if (message.includes('not found')) {
    //   setError(ErrorTypes.USER_NOT_FOUND);
    // } else if (message === Constants.ErrorType.NotAuthourized) {
    //   setError(ErrorTypes.NOT_AUTHORIZED);
    // } else {
    //   setError('An unknown error occurred');
    // }
  };
  public static formatTime = (date: Date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? hours : 12; // 0 becomes 12
    minutes = minutes < 10 ? 0 + minutes : minutes; // Add leading zero for minutes
    return `${hours}:${minutes} ${ampm}`;
  };
  public static getMatchingRecordTypeKey = (
    dealTypeSelected: string,
    recordType: Record<string, string>,
  ) => {
    // Find the matching key by comparing the values in recordType with dealTypeSelected
    const matchingKey = Object.keys(recordType).find((key) => recordType[key] === dealTypeSelected);

    return matchingKey || null; // Return the matching key or null if no match is found
  };
  public static parseDDMMYYYY = (dateStr: string): Date => {
    // Split by common separators
    const parts = dateStr.split(/[\/\-\.]/);
    if (parts.length === 3) {
      const [day, month, year] = parts;
      // Create date in YYYY, MM-1, DD format (month is 0-indexed)
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }

    // Fallback to current date if parsing fails
    console.warn(`Unable to parse date: ${dateStr}`);
    return new Date();
  };
  public static formatGMTOffset = (offsetHours: number): string => {
    const absHours = Math.abs(offsetHours);
    const sign = offsetHours >= 0 ? '+' : '-';

    // Handle half-hour timezones (e.g., India +5:30, Australia +9:30)
    if (offsetHours % 1 !== 0) {
      const hours = Math.floor(absHours);
      const minutes = Math.round((absHours % 1) * 60);
      return `${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
    }

    return `${sign}${absHours}`;
  };
  public static downloadCSV = (csvContent: any, fileName: string) => {
    // Create a "Blob" (a file-like object) from the raw string
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a temporary link element
    const link = document.createElement('a');

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);

    // Set the file name for the download
    link.setAttribute('download', fileName);

    // Make the link invisible
    link.style.visibility = 'hidden';

    // Append to the DOM, "click" it, and then remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
}
